export enum ReportsActionsEnum {
  REPORTS_DOWNLOAD_EXTENDED_REPORT = 'REPORTS_DOWNLOAD_EXTENDED_REPORT',
}
